module.exports = __webpack_public_path__ + "door-knock.8cc3baf1.mp3";